module.exports = __webpack_public_path__ + "img/6X4.e765435b.png";